<template>
    <div
            class="diary-project-comments"
            :class="{'diary-project-comments_mobile': $vuetify.breakpoint.xsOnly}"
    >
        <v-expansion-panels
            v-model="expansionPanel"
            accordion
            tile
            flat
        >
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div
                        class="diary-project-comments__label"
                    >{{ $t('msg.comments') }}<span class="ml-4 mr-4">{{ localCount }}</span></div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-progress-linear
                            v-if="loading"
                            indeterminate
                    ></v-progress-linear>
                    <div
                            v-if="!loading"
                            v-for="item in comments"
                            :key="item.id"
                            class="diary-project-comments__item"
                    >
                        <div
                            class="diary-project-comments__author"
                        >
                            <login v-model="item.login"></login>
                            <div class="diary-project-comments__date">{{ dateString(item.date) }} {{ item.date | dateMin }}</div>
                            <btn-edit
                                v-if="item.is_my_comment"
                                @click="openEdit(item)"
                                class="ml-1"
                            ></btn-edit>
                        </div>
                        <div class="diary-project-comments__msg">{{ item.msg }}</div>
                    </div>
                    <div
                            v-if="!loading"
                            class="diary-project-comments__bottom"
                    >
                        <v-btn
                            v-if="!isOpenForm"
                            :small="!isMobile"
                            @click="openForm()"
                            color="primary"
                            elevation="0"
                        >{{ $t('msg.addComment') }}</v-btn>
                    </div>
                    <form-comment
                        v-if="isOpenForm"
                        :target-id="targetId"
                        :target-dairy-id="targetDairyId"
                        @close-form="isOpenForm = false"
                        @created="comment => {
                            this.comments.push(comment);
                            isOpenForm = false;
                            localCount++;
                        }"
                        @updated="comment => {
                            isOpenForm = false;
                        }"
                        class="diary-project-comments__form"
                        ref="formComment"
                    ></form-comment>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import FormComment from './FormComment';
import Login from "../../ui/Login";
import BtnEdit from "../../ui/BtnEdit";

export default {
    components: {FormComment, Login, BtnEdit},
    props: {
        count: {type: Number, default: 0},
        targetId: {type: Number, default: 0},
        targetDairyId: {type: Number, default: 0},
    },
    data() {
        return {
            comments: [],
            isOpenForm: false,
            comment: null,
            expansionPanel: undefined,
            localCount: this.count,
            loading: false
        }
    },
    watch: {
        expansionPanel(v) {
            if (v !== undefined) {
                this.loadComments();
            }
        },
        localCount(v) {
            this.$emit('update:count', v);
        }
    },
    methods: {
        openForm() {
            this.isOpenForm = true;
            setTimeout(() => {
                this.$refs.formComment.model.id = null;
                this.$refs.formComment.model.msg = null;
            }, 100)
        },
        loadComments() {
            this.loading = true;
            this.$store.dispatch('loadTargetDairyComments', {
                id: this.targetId,
                subId: this.targetDairyId,
            })
                .then(res => this.comments = res)
                .finally(() => this.loading = false);
        },
        openEdit(comment) {
            this.isOpenForm = true;

            setTimeout(() => {
                this.$refs.formComment.model = comment;
            }, 100)
        }
    }
}
</script>

<style lang="scss">
.diary-project-comments {
    &.diary-project-comments_mobile {
        .v-expansion-panel-header {
            padding-left: 10px;
            padding-right: 10px;
        }
        .v-expansion-panel-content__wrap {
            padding-left: 10px;
            padding-right: 10px;
        }
    }
}
.diary-project-comments__item {
    margin-top: 10px;
}
.diary-project-comments__author {
    display: flex;
    align-items: center;
}
.diary-project-comments__msg {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.0071428571em;
    color: rgba(0, 0, 0, 0.6);
}
.diary-project-comments__date {
    font-size: 12px;
    font-style: italic;
    margin-left: 10px;
}
.diary-project-comments__bottom {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}
.diary-project-comments__form {
    margin-top: 10px;
}
</style>